import { connect } from "knockout-store";
import { pushRoute, r } from "../../utils/routing";
import introductionJs from "./introduction";
import { refresh } from "../storyline/storyline";
import axios from "axios";
import ko from "knockout";
import { t } from "../../utils/translations";

function introductionViewModel(params) {
  setTimeout(() => {
    introductionJs();
  }, 0);

  function check(value) {
    if (params.route() === r("introduction") && !params.introDataLoading()) {
      params.introDataLoading(true);

      Promise.all([
        axios.get(
          `${process.env.CONTENT_URL}/${process.env.LANGUAGE}_${process.env.STORY_LINE}.json`
        ),
      ])
        .then(([intro]) => [intro.data])
        .then(([intro]) => {
          params.introData(intro);
          vm.dataLoading(false);
        });
    }
  }

  params.route.subscribe(function (newValue) {
    check(newValue);
  });

  const vm = {};
  vm.visible = () => params.route() === r("introduction");
  vm.data = () => params.introData();
  vm.dataLoading = ko.observable(true);
  vm.translation = (key) => t(key);
  vm.route = (key) => r(key);
  vm.goTo = (url) => {
    pushRoute(url, params.route);
  };
  vm.goToPart = (partID, chapterID) => {
    pushRoute(r("storyline"), params.route);

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });

    params.currentPartID(partID);
    refresh(partID, chapterID);
  };
  check(params.route());

  return vm;
}

function mapStateToParams({
  route,
  currentPartID,
  introDataLoading,
  introData,
}) {
  return { route, currentPartID, introDataLoading, introData };
}

export default connect(mapStateToParams)(introductionViewModel);
